<template>
  <div class="total-transaction-pannel">
    <div class="total-title">
      <div>
        {{ $t('dashboard.today_overview') }}
        <el-tooltip v-if="$store.getters.isPii" placement="bottom">
          <div slot="content">
            <span>{{ $t('tips.current_time_zone') }}</span>
          </div>
          <span><svg-icon icon-class="icon-font-warning" style="width: 22px;color: #3855F1;cursor: pointer;" /></span>
        </el-tooltip>
      </div>
      <el-select
        v-if="$store.getters.isAllCountry"
        v-model="currency"
        class="currency-select"
        size="small"
        :placeholder="$t('data.currency')"
        @change="handleCurrencyChange"
      >
        <el-option
          v-for="(item, index) in $store.state.page.countryArr"
          :key="index"
          :label="item.currency"
          :value="item.currency"
        />
      </el-select>
    </div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane :label="$t('dashboard.total_transaction')" name="first">
        <el-row :gutter="20" class="panel-group">
          <el-col :span="8" class="card-panel-col">
            <div class="card-panel">
              <div class="card-panel-text">
                {{ $t('dashboard.transaction_count') }}
              </div>
              <div class="card-panel-num">{{ overviewData.total_count || 0 }}</div>
            </div>
          </el-col>
          <el-col :span="8" class="card-panel-col">
            <div class="card-panel">
              <div class="card-panel-text">
                {{ $t('dashboard.transaction_amount') }}
              </div>
              <div class="card-panel-num">{{ overviewData.total_amount | toDivideWithDot }}</div>
            </div>
          </el-col>

          <el-col :span="8" class="card-panel-col">
            <div class="card-panel">
              <div class="card-panel-text">
                {{ $t('dashboard.transaction_fee') }}
              </div>
              <div class="card-panel-num">{{ overviewData.total_fee | toDivideWithDot }}</div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>

      <el-tab-pane :label="$t('dashboard.payin')" name="second">
        <el-row :gutter="20" class="panel-group">
          <el-col :span="8" class="card-panel-col">
            <div class="card-panel">
              <div class="card-panel-text">
                {{ $t('dashboard.transaction_count') }}
              </div>
              <div class="card-panel-num">{{ overviewData.payment_count || 0 }}</div>
            </div>
          </el-col>
          <el-col :span="8" class="card-panel-col">
            <div class="card-panel">
              <div class="card-panel-text">
                {{ $t('dashboard.transaction_amount') }}
              </div>
              <div class="card-panel-num">{{ overviewData.payment_total_amount | toDivideWithDot }}</div>
            </div>
          </el-col>
          <el-col :span="8" class="card-panel-col">
            <div class="card-panel">
              <div class="card-panel-text">
                {{ $t('dashboard.transaction_fee') }}
              </div>
              <div class="card-panel-num">{{ overviewData.payment_fee | toDivideWithDot }}</div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane name="third">
        <span slot="label">
          {{ $t('dashboard.payout') }}
        </span>
        <el-row :gutter="20" class="panel-group">
          <el-col :span="8" class="card-panel-col">
            <div class="card-panel">
              <div class="card-panel-text">
                {{ $t('dashboard.transaction_count') }}
              </div>
              <div class="card-panel-num">{{ overviewData.payout_count || 0 }}</div>
            </div>
          </el-col>
          <el-col :span="8" class="card-panel-col">
            <div class="card-panel">
              <div class="card-panel-text">
                {{ $t('dashboard.transaction_amount') }}
              </div>
              <div class="card-panel-num">{{ overviewData.payout_total_amount | toDivideWithDot }}</div>
            </div>
          </el-col>

          <el-col :span="8" class="card-panel-col">
            <div class="card-panel">
              <div class="card-panel-text">
                {{ $t('dashboard.transaction_fee') }}
              </div>
              <div class="card-panel-num">{{ overviewData.payout_fee | toDivideWithDot }}</div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>
// import CountTo from 'vue-count-to'
import { fetchMultiMchTodayTotalData, fetchTodayTotalData } from '@/api/dashboard/dashboard.js'
export default {
  // components: {
  //   CountTo
  // },
  data() {
    const firstCountry = this.$store.state.page.countryArr[0]
    return {
      overviewData: {
        payment_count: '0',
        payment_total_amount: '0',
        payout_count: '0',
        payout_total_amount: '0'
      },
      currency: firstCountry ? firstCountry.currency : undefined,
      activeName: 'first'
    }
  },
  watch: {
    activeName: {
      handler(newValue, oldValue) {
        this.changeShowType(newValue)
      }
    },
    '$store.state.page.countryArr': {
      handler(countryArr) {
        if (!this.$store.getters.isAllCountry || this.currency || !countryArr.length) {
          return
        }
        this.currency = countryArr[0].currency
        this.handleCurrencyChange(this.currency)
      }
    }
  },
  created() {
    const { token } = this.$store.getters
    if (token) {
      if (this.$store.getters.isAllCountry) {
        if (this.currency) {
          this.handleCurrencyChange(this.currency)
        }
      } else {
        this.getOverviewData()
      }
    }
  },
  methods: {
    getOverviewData() {
      const isAllCountry = this.$store.getters.isAllCountry
      const params = isAllCountry
        ? { currency: this.currency }
        : {}
      const fetchTotalData = isAllCountry
        ? fetchMultiMchTodayTotalData
        : fetchTodayTotalData
      fetchTotalData(params).then(res => {
        const {
          payment_count,
          payout_count,
          payment_total_amount,
          payout_total_amount,
          payout_fee,
          payment_fee
        } = res.data

        this.overviewData = {
          payment_count,
          payout_count,
          payout_fee,
          payment_total_amount,
          payout_total_amount,
          payment_fee,
          total_amount: +payment_total_amount + +payout_total_amount,
          total_count: +payment_count + +payout_count,
          total_fee: +payout_fee + +payment_fee
        }
      })
    },
    handleCurrencyChange(currency) {
      this.getOverviewData()
      this.$emit('currency-change', currency)
    },
    handleSetLineChartData(type) {
      this.$emit('handleSetLineChartData', type)
    },
    changeShowType(type) {
      this.$emit('changeShowType', type)
    }
  }
}
</script>
<style lang="scss" scoped>
.total-transaction-pannel{
  margin-top: 32px;
  .total-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #1D3A71;
    font-family: "Inter-Bold";
    font-size: 24px;
    font-weight: 700;
    padding-bottom: 32px;
    .currency-select {
      width: 90px;
    }
  }
}
.panel-group {
  padding-top: 17px;
  padding-bottom: 32px;
  border-bottom: 1px solid #D3D7DF;
  .card-panel-col{
    .card-panel {
      position: relative;
      box-sizing: border-box;
      margin-right: 16px;
      padding: 18px 24px;
      border: 1.5px solid #D3D7DF;
      border-radius: 8px;
      overflow: hidden;
      .card-panel-text {
        font-weight: 500;  font-family: 'Inter-Medium';
        font-size: 14px;
        line-height: 1.2;
        margin-bottom:16px;
        color: #4B5567;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .card-panel-num {
        font-weight: 600;  font-family: 'Inter-SemiBold';
        font-size: 24px;
        line-height: 1.2;
        color: #3855F1;
        word-wrap:break-word;
      }
    }
  }
}
// @media screen and (max-width: 376px) {
//   .panel-group {
//     .card-panel-col {
//       width: 100%;
//     }
//   }
// }
</style>
